import React from "react";
import { namaBulan } from "../../helpers";

// const PrintTtd = ({
//   tanggal,
//   cabang,
//   nama,
//   jabatan,
//   footer,
//   menyetujui = false,
// }) => {
//   return (
//     <div className="w-100 text-center">
//       <>
//         {/* <div className="row justify-content-end mb-5"> */}
//         {/* </div> */}
//       </>
//       <span style={{ textTransform: "capitalize" }}>
//         {cabang ? `${cabang},` : ""}
//       </span>{" "}
//       {tanggal ? (
//         <>
//           {tanggal === "default" ? (
//             <>
//               {new Date().getDate()} {namaBulan[new Date().getMonth()]}{" "}
//               {new Date().getFullYear()}
//             </>
//           ) : (
//             tanggal
//           )}
//         </>
//       ) : (
//         <></>
//       )}{" "}
//       <br />
//       <span style={{ textTransform: "capitalize" }}>{jabatan}</span>{" "}
//       {menyetujui ? "Menyetujui," : "Alfa Prima "}
//       {cabang && `${cabang.charAt(0).toUpperCase()}${cabang.slice(1)}`} <br />
//       <br />
//       <br />
//       <br />
//       <br />
//       <b>
//         <u>{nama}</u>
//       </b>
//       <br />
//       {footer}
//     </div>
//   );
// };

const PrintTtd = ({ tanggal, cabang, nama, jabatan, menyetujui = false, footer, userCabang }) => {
  return (
    <div className="w-100 text-center">
      <>
        {/* <div className="row justify-content-end mb-5"> */}
        {/* </div> */}
      </>
      <b>
        <span style={{ textTransform: "capitalize" }}>
          {cabang ? `${cabang},` : ""}
        </span>{" "}
        {tanggal ? (
          <>
            {tanggal === "default" ? (
              <>
                {new Date().getDate()} {namaBulan[new Date().getMonth()]}{" "}
                {new Date().getFullYear()}
              </>
            ) : (
              tanggal
            )}
          </>
        ) : (
          <></>
        )}{" "}
        <br />
        {menyetujui ? (
          <span>
            <br />
            Menyetujui,
          </span>
        ) : (
          <span>
            Lembaga Pelatihan Kerja
            <br />
            Alfa Prima{" "}
          </span>
        )}
      </b>
      <br />
      <br />
      <br />
      <br />
      <b>
        <u>
          {/* {userCabang} */}
          {/* {cabang && cabang.toUpperCase() === "DENPASAR" || cabang.toUpperCase() === "PUSAT" ? "true" : "false"} */}
          {userCabang && (userCabang.toUpperCase() === "DENPASAR" || userCabang.toUpperCase() === "PUSAT") && !menyetujui
            // ? "Putu Trisna Hady Permana S., S.Pd., M.Kom."
            ? "Luh Putu Ika Primayanti, S.IP., M.Han"
            : nama}
        </u>
      </b>
      <br />
      <span style={{ textTransform: userCabang && (userCabang.toUpperCase() === "DENPASAR" || userCabang.toUpperCase() === "PUSAT") && !menyetujui ? "none" : "capitalize" }}>
        {userCabang && (userCabang.toUpperCase() === "DENPASAR" || userCabang.toUpperCase() === "PUSAT") && !menyetujui ? "Direktur Akademik dan Kemahasiswaan" : jabatan} {!menyetujui && "Alfa Prima"}
      </span>{" "}
      {userCabang && userCabang.toUpperCase() !== "DENPASAR" && userCabang.toUpperCase() !== "PUSAT" && <span style={{ textTransform: "capitalize" }}>{cabang}</span>}
      {/* <br /> */}
      {menyetujui && "Instruktur"}
      {/* {footer} */}
    </div>
  );
};

export default PrintTtd;























export const PrintTtdManual = ({ cabang }) => {

  if (!cabang) return null;

  if (cabang) {
    return (
      <div className="w-100 text-center">
        <b>
          <span style={{ textTransform: "capitalize" }}>{cabang}</span>{" "}
          {new Date().getDate()} {namaBulan[new Date().getMonth()]}{" "}
          {new Date().getFullYear()}
          <br />
          <span>
            Lembaga Pelatihan Kerja
            <br />
            Alfa Prima{" "}
          </span>
        </b>
        <br /><br /><br /><br />
        <b>
          <u>
            {cabang === "denpasar" || cabang === "pusat" ? (
              "Luh Putu Ika Primayanti, S.IP., M.Han"
            ) : cabang === "singaraja" ? (
              "Gede Guna Parna, S.Pd."
            ) : cabang === "karangasem" && (
              "I Made Bagus Alviantara, S.Kom."
            )}
          </u>
        </b>
        <br />
        <span>
          {cabang === "denpasar" || cabang === "pusat" ? (
            "Direktur Akademik dan Kemahasiswaan Alfa Prima"
          ) : cabang === "singaraja" ? (
            "Kepala Cabang Alfa Prima Singaraja"
          ) : cabang === "karangasem" && (
            "Kepala Cabang Alfa Prima Karangasem"
          )}
        </span>
      </div>
    );
  }
};